const prepareNumericalValue = (value) => {
	return value.length > 1 && value.charAt(0) === '0' && /^\d+$/.test(value) ? value.substring(1) : value;
}

export default prepareNumericalValue;
